<template>
  <div>
    <!-- container -->
    <div v-if="info.param_params">
      <!-- group -->
      <div
        class="grid grid-cols-1 gap-6 md:grid-cols-2"
        v-if="info.param_params.length > 0"
      >
        <template v-if="info.investment_type === 'PORTFOLIO'">
          <portfolio-edit-component
            v-for="(group, group_key) in info.param_params[section_index]
              .groups"
            :key="group_key"
            :data="group"
          />
        </template>
        <template v-else>
          <param-group-component
            v-for="(group, group_key) in info.param_params[section_index]
              .groups"
            :key="group_key"
            :group="group"
          />
        </template>
        <!-- end of group -->
      </div>
    </div>
    <placeholderCard v-show="!info.param_params" />

    <!-- end of container -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {
    placeholderCard: () =>
      import("@/app/shared/components/placeholder/placeholder-card.component"),
    PortfolioEditComponent: () =>
      import("./portfolio/portfolio-edit.component.vue"),
    ParamGroupComponent: () => import("./param-group.component.vue"),
  },

  computed: {
    ...mapGetters({
      info: "investment/getParametersInfo",
      section_index: "investment/getSectionIndex",
    }),
  },
};
</script>

<style lang="scss">
.vue-number-input {
  border: none !important;
  /* background-color: #171e27 !important; */
}
.vue-number-input .vue-number-input__btn-dec {
  background-color: #4a5568 !important;
  border-radius: 0.25rem;
  /* border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem; */
  outline: none;
}
.vue-number-input .vue-number-input__btn-inc {
  background-color: #4a5568 !important;
  border-radius: 0.25rem;
  /* border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem; */
  outline: none;
}
.vue-number-input .vue-number-input__input {
  background-color: #171e27 !important;
  color: white !important;
  text-align: center;
  font-weight: 500;
  margin: 0 0.5rem;
}
.vue-number-input-btn__symbol {
  color: white !important;
  font-size: 14px !important;
}
.vue-number-input .vue-number-input__input {
  width: 75px !important;
  height: 34px !important;
  padding: 5px !important;
  border-radius: 0.25rem !important;
  outline: none;
  border: 1px solid #171e27;
}
.vue-number-input.vue-number-input_on-edge .vue-number-input__btn-dec,
.vue-number-input.vue-number-input_on-edge .vue-number-input__btn-inc {
  min-width: 34px !important;
  width: 34px !important;
  min-height: 34px !important;
  height: 34px !important;
}
.vue-number-input-btn__default .vue-number-input-btn__symbol {
  padding: 8px 0 !important;
}

.vue-number-input.vue-number-input_inactive {
  @apply bg-gray-300 dark:bg-ontick-graphite-500 #{!important};
}
</style>
